import React from 'react';
import { storiesOf } from '@storybook/react';
import { action } from '@storybook/addon-actions';
import FilenameTemplate from './FilenameTemplate';

const filenameTemplateInitProp = {
  isLoading: false,
  created: null,
  modified: null,
  date_format: null,
  selectedFields: [],
  errorMessage: null,
  savedFileFormatFields: [],
  selectedFileFormatFields: [],
  savedFolderPathFields: [],
  selectedFolderPathFields: [],
};

storiesOf('Filename Templates', module)
  .add('Empty', () => (
    <div>
      <FilenameTemplate filenameTemplate={filenameTemplateInitProp}
                        dispatch={action('dispatch')}
                        connectionId={1} />
    </div>
  ))
  .add('loading', () => (
    <div>
      <FilenameTemplate filenameTemplate={{...filenameTemplateInitProp, isLoading: true}}
                        dispatch={action('dispatch')}
                        connectionId={1} />
    </div>
  ))
  .add('With Valid Selections', () => (
    <div>
      <FilenameTemplate
        filenameTemplate={{
          ...filenameTemplateInitProp,
          selectedFields: ['case_id', '_', 'case_title', 'case_number', '.', 'court_name'],
        }}
        dispatch={action('dispatch')}
        connectionId={1} />
    </div>
  ))
  .add('Without Folder Options', () => (
    <div>
      <FilenameTemplate
        filenameTemplate={filenameTemplateInitProp}
        dispatch={action('dispatch')}
        requireFolderConfiguration
      connectionId={1} />
    </div>
  ))
;



// WEBPACK FOOTER //
// ./src/Integrations/connections/FilenameTemplate/FilenameTemplate.stories.jsx